var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "robot-design robot3s" }, [
    _c("div", { staticClass: "banner", attrs: { id: "design-b1" } }, [
      _c(
        "div",
        { staticClass: "bg-mask", class: { fadeUp: _vm.isB1Visible } },
        [
          _c(
            "div",
            { staticClass: "p1 delay1", class: { fadeUp: _vm.isB1Visible } },
            [_vm._v("机器人运营管理平台")]
          ),
          _c(
            "div",
            { staticClass: "p2 delay2", class: { fadeUp: _vm.isB1Visible } },
            [_vm._v("将机器人等多智能终端和机构运营管理服务相结合")]
          ),
          _c(
            "div",
            { staticClass: "p2 delay3", class: { fadeUp: _vm.isB1Visible } },
            [
              _vm._v(
                "将管理长者安全守护/生活照护智能服务与机构处理通报流程整合为一体化的AI运营管理平台"
              )
            ]
          ),
          _c(
            "div",
            {
              staticClass: "item delay4",
              class: { fadeDown: _vm.isB1Visible }
            },
            [
              _vm.isMobile
                ? _c("img", {
                    attrs: {
                      src: require("../../../assets/mobile/3s-platform-img1.png")
                    }
                  })
                : _c("img", {
                    attrs: {
                      src: require("../../../assets/web/3s-platform-img1.png")
                    }
                  })
            ]
          )
        ]
      )
    ]),
    _c("div", { staticClass: "banner", attrs: { id: "design-b2" } }, [
      _c(
        "div",
        { staticClass: "p1 delay1", class: { zoomOut: _vm.isB2Visible } },
        [_vm._v("登录界面")]
      ),
      _c(
        "div",
        { staticClass: "item delay2", class: { zoomOut: _vm.isB2Visible } },
        [
          _vm.isMobile
            ? _c("img", {
                attrs: {
                  src: require("../../../assets/mobile/3s-platform-img2.png")
                }
              })
            : _c("img", {
                attrs: {
                  src: require("../../../assets/web/3s-platform-img2.png")
                }
              })
        ]
      )
    ]),
    _c("div", { staticClass: "banner", attrs: { id: "design-b3" } }, [
      _c(
        "div",
        { staticClass: "p1 delay1", class: { zoomOut: _vm.isB3Visible } },
        [_vm._v("公告界面")]
      ),
      _c(
        "div",
        { staticClass: "item delay2", class: { zoomOut: _vm.isB3Visible } },
        [
          _vm.isMobile
            ? _c("img", {
                attrs: {
                  src: require("../../../assets/mobile/3s-platform-img3.png")
                }
              })
            : _c("img", {
                attrs: {
                  src: require("../../../assets/web/3s-platform-img3.png")
                }
              })
        ]
      )
    ]),
    _c("div", { staticClass: "banner", attrs: { id: "design-b4" } }, [
      _c(
        "div",
        { staticClass: "p1 delay1", class: { zoomOut: _vm.isB4Visible } },
        [_vm._v("视频通话界面")]
      ),
      _c(
        "div",
        { staticClass: "item delay2", class: { zoomOut: _vm.isB4Visible } },
        [
          _vm.isMobile
            ? _c("img", {
                attrs: {
                  src: require("../../../assets/mobile/3s-platform-img4.png")
                }
              })
            : _c("img", {
                attrs: {
                  src: require("../../../assets/web/3s-platform-img4.png")
                }
              })
        ]
      )
    ]),
    _c("div", { staticClass: "banner", attrs: { id: "design-b5" } }, [
      _c(
        "div",
        { staticClass: "p1 delay1", class: { zoomOut: _vm.isB5Visible } },
        [_vm._v("工单界面")]
      ),
      _c(
        "div",
        { staticClass: "item delay2", class: { zoomOut: _vm.isB5Visible } },
        [
          _vm.isMobile
            ? _c("img", {
                attrs: {
                  src: require("../../../assets/mobile/3s-platform-img5.png")
                }
              })
            : _c("img", {
                attrs: {
                  src: require("../../../assets/web/3s-platform-img5.png")
                }
              })
        ]
      )
    ]),
    _c("div", { staticClass: "banner", attrs: { id: "design-b6" } }, [
      _c(
        "div",
        { staticClass: "p1 delay1", class: { zoomOut: _vm.isB6Visible } },
        [_vm._v("概览界面")]
      ),
      _c(
        "div",
        { staticClass: "item delay2", class: { zoomOut: _vm.isB6Visible } },
        [
          _vm.isMobile
            ? _c("img", {
                attrs: {
                  src: require("../../../assets/mobile/3s-platform-img6.png")
                }
              })
            : _c("img", {
                attrs: {
                  src: require("../../../assets/web/3s-platform-img6.png")
                }
              })
        ]
      )
    ]),
    _c("div", { staticClass: "banner", attrs: { id: "design-b7" } }, [
      _c(
        "div",
        { staticClass: "p1 delay1", class: { zoomOut: _vm.isB7Visible } },
        [_vm._v("发布公告")]
      ),
      _c(
        "div",
        { staticClass: "item delay2", class: { zoomOut: _vm.isB7Visible } },
        [
          _vm.isMobile
            ? _c("img", {
                attrs: {
                  src: require("../../../assets/mobile/3s-platform-img7.png")
                }
              })
            : _c("img", {
                attrs: {
                  src: require("../../../assets/web/3s-platform-img7.png")
                }
              })
        ]
      )
    ]),
    _c("div", { staticClass: "banner", attrs: { id: "design-b8" } }, [
      _c(
        "div",
        { staticClass: "p1 delay1", class: { fadeUp: _vm.isB8Visible } },
        [_vm._v("多维闭环机器人智能运营")]
      ),
      _c("div", { staticClass: "item" }, [
        _vm.isMobile
          ? _c(
              "div",
              { staticClass: "delay2", class: { fadeDown: _vm.isB8Visible } },
              [
                _c("img", {
                  staticClass: "img1",
                  attrs: {
                    src: require("../../../assets/mobile/3s-platform-img8.png")
                  }
                }),
                _c("img", {
                  staticClass: "img2",
                  attrs: {
                    src: require("../../../assets/mobile/3s-platform-img9.png")
                  }
                })
              ]
            )
          : _vm._e(),
        !_vm.isMobile
          ? _c(
              "div",
              { staticClass: "delay2", class: { fadeDown: _vm.isB8Visible } },
              [
                _c("img", {
                  staticClass: "img1",
                  attrs: {
                    src: require("../../../assets/web/3s-platform-img8.png")
                  }
                }),
                _c("img", {
                  staticClass: "img2",
                  attrs: {
                    src: require("../../../assets/web/3s-platform-img9.png")
                  }
                })
              ]
            )
          : _vm._e()
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-51f0bf84", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-51f0bf84","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/robot/3s/design.vue
// module id = MGcR
// module chunks = 0